// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Translate';



// WEBPACK FOOTER //
// ./components/Translate/index.js